import { makeStyles } from "@material-ui/core/styles";

/** Shared by the duplicate checker and the inventory import grids. */
export const PendingInventoryGridHeaderHeight = 39;

export const usePendingInventoryGridStyles = makeStyles({
  content: {
    flex: "1 1 auto",
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    // Let the grid sit flush against the dialog edges. `&&` also beats the
    // padding DialogContent applies, including the larger dividers variant.
    "&&": {
      padding: 0,
    },
  },
  grid: {
    flex: "1 1 auto",
    minHeight: 0,
    border: "none",
    "& .MuiDataGrid-cell": {
      display: "flex",
      alignItems: "center",
      whiteSpace: "normal",
      lineHeight: "normal",
    },
    "& .MuiDataGrid-cell > *": {
      alignSelf: "center",
      maxHeight: "100%",
    },
  },
});
